import type { RGBA } from "./types";

/** 解析 "R,G,B[,A]" 形式的颜色（参考实现 ini 里的写法），取值范围 0~255 */
export function parseColor(input: string, fallback: RGBA = [255, 255, 255, 255]): RGBA {
  const parts = input
    .replace(/;/g, ",")
    .split(",")
    .map((p) => p.trim())
    .filter((p) => p.length > 0);
  if (parts.length < 3) return fallback;
  const nums = parts.map((p) => Number.parseFloat(p));
  if (nums.some((n) => Number.isNaN(n))) return fallback;
  const clamp = (v: number) => Math.max(0, Math.min(255, Math.round(v)));
  return [clamp(nums[0]), clamp(nums[1]), clamp(nums[2]), clamp(nums.length > 3 ? nums[3] : 255)];
}

export function rgbaCss(c: RGBA): string {
  return `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${(c[3] / 255).toFixed(4)})`;
}

export function hexToRgb(hex: string): [number, number, number] {
  const h = hex.replace("#", "");
  return [
    Number.parseInt(h.slice(0, 2), 16) || 0,
    Number.parseInt(h.slice(2, 4), 16) || 0,
    Number.parseInt(h.slice(4, 6), 16) || 0,
  ];
}

export function rgbToHex(rgb: [number, number, number]): string {
  return `#${rgb.map((v) => v.toString(16).padStart(2, "0")).join("")}`;
}
